import axios from "@/store/axios";
import {V1API} from "@/http/APIPath";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";
import dataMagic, {decode, encode} from "@/store/dataMagic"
import ToastificationContent from "@core/components/toastification/ToastificationContent";

const keyList = {
    adUpdate : 'AD_UPDATE',
    adDelete : 'AD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        allUserNotifications: [],
        allUserEmail: [],
        categories: [],
        categoriesLoading: false,
        categoriesError: false,
        settings: {},
        adLoading: false,
        adError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        ...store
    },

    mutations : {
        ...mutations,

        AD_LOADING (state, loading) {
            state.adLoading = loading;
        },

        SET_SETTINGS (state, setting) {
            state.settings = setting;
        },

        SET_CATEGORY (state, categories) {
            state.categories = categories;
        },

        SET_ALL_USER_NOTIFICATIONS (state, notifications) {
            state.allUserNotifications = notifications;
        },

        SET_ALL_USER_EMAIL (state, emails) {
            state.allUserEmail = emails;
        },

        CATEGORY_LOADING (state, loading) {
            state.categoriesLoading = loading;
        },

        CATEGORY_ERROR(state, error) {
            state.categoriesError = error;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        AD_ERROR(state, error) {
            state.submitError = error;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async addAdditionalSettings({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let magic=encode(payload)
                let response = await axios.post(V1API.create_additional_settings, magic.encodedPayload, magic.config).then(result=>{
                    let data = decode(result.data)
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAdditionalSettings')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
                return { error: true, response: e.response.data.response };
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async fetchAdditionalSettings ({ commit }) {
            commit('AD_LOADING', true);
            commit('AD_ERROR', false);
            try{
                let result = await axios.get(V1API.get_additional_settings);
                let response = decode(result.data.data)
                commit('SET_SETTINGS', response); 
            }catch(error) {
                commit('AD_ERROR', true);
            }
            commit('AD_LOADING', false);
        },

        async fetchNotificationCategories ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);
            try{
                let result = await axios.get(V1API.get_notification_categories);
                let response = decode(result.data.settings)
                commit('SET_CATEGORY', response); 
            }catch(error) {
                commit('CATEGORY_ERROR', true);
            }
            commit('CATEGORY_LOADING', false);
        },

        async toggleNotificationCategory({commit, dispatch}, payload) {
            let magic=encode(payload)
            let response = await axios.post(V1API.toggle_notification_category, magic.encodedPayload, magic.config).then(result=>{
                let data = decode(result.data)
                return data
            });
            commit('SUBMIT_SUCCESS', true);
            dispatch ('fetchNotificationCategories')
            return response
        },


        // All User Notification Actions
        async getAllUserNotifications ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);
            try{
                let result = await axios.get(V1API.get_all_user_notifications);
                let response = decode(result.data.data)
                commit('SET_ALL_USER_NOTIFICATIONS', response); 
            }catch(error) {
                commit('CATEGORY_ERROR', true);
            }
            commit('CATEGORY_LOADING', false);
        },

        async pushAllUserNotification({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let magic=encode(payload)
                let response = await axios.post(V1API.push_all_user_notification, magic.encodedPayload, magic.config).then(result=>{
                    let data = decode(result.data)
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('getAllUserNotifications')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
                return { error: true, response: e.response.data.response };
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        // All User Notification Actions
        async getallUserEmail ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);
            try{
                let result = await axios.get(V1API.get_all_user_email);
                let response = decode(result.data.data)
                commit('SET_ALL_USER_EMAIL', response); 
            }catch(error) {
                commit('CATEGORY_ERROR', true);
            }
            commit('CATEGORY_LOADING', false);
        },

        async pushAllUserEmail({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let magic=encode(payload)
                let response = await axios.post(V1API.push_all_user_email, magic.encodedPayload, magic.config).then(result=>{
                    let data = decode(result.data)
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('getallUserEmail')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
                return { error: true, response: e.response.data.response };
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        }
    },

    getters: {}
}